import React from "react";

export const MAX_CELL_CHARS = 25;

export const truncateText = (value: unknown, max = MAX_CELL_CHARS): string => {
  const text = value === null || value === undefined ? "" : String(value).trim();
  const chars = Array.from(text);
  return chars.length > max ? `${chars.slice(0, max).join("")}…` : text;
};

// Shows at most `max` characters (default 25) and the full text on hover;
// an empty value shows `fallback`.
const TruncatedText: React.FC<{
  value: unknown;
  max?: number;
  fallback?: string;
  className?: string;
}> = ({ value, max = MAX_CELL_CHARS, fallback = "—", className }) => {
  const full = value === null || value === undefined ? "" : String(value).trim();
  if (!full) return <span className={`text-gray-400 ${className ?? ""}`}>{fallback}</span>;
  const shown = truncateText(full, max);
  return (
    <span className={`whitespace-nowrap ${className ?? ""}`} title={shown !== full ? full : undefined}>
      {shown}
    </span>
  );
};

export default TruncatedText;
